import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 1,
  class: "size-7 shrink-0",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 1,
  class: "flex"
}
const _hoisted_4 = {
  key: 1,
  class: "flex w-full items-center gap-2 px-2"
}
const _hoisted_5 = { class: "flex shrink-0" }

import {
        EditableArea,
        EditableCancelTrigger,
        EditableEditTrigger,
        EditableInput,
        EditablePreview,
        EditableRoot,
        EditableSubmitTrigger,
    } from 'reka-ui';
    import { Button } from '@/components/ui/button';
    import { Check, Globe, Lock, Pencil, X } from 'lucide-vue-next';
    import { useI18n } from 'vue-i18n';
    import type { UserTableViewOption } from '@/types';
    import { useViewOptionsStore } from '@/stores/view-options';
    import ViewOptionDelete from '@/components/ViewOptionDelete.vue';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import { computed, ref } from 'vue';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';

    interface Props {
        viewOption: UserTableViewOption;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ViewOption',
  props: {
    viewOption: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const name = ref(props.viewOption.name);

    const viewOptionsStore = useViewOptionsStore();
    const { hasPermission } = usePermissions();

    // Only the owner of a (non-default) view may rename, delete or share it.
    const canManage = computed(() => props.viewOption.is_owner && !props.viewOption.is_default);
    const canShareGlobal = computed(() => hasPermission(Permission.DASHBOARD_ADMIN_SHARE_GLOBAL));

    const isActive = computed(
        () => viewOptionsStore.activeViewOption?.id === props.viewOption.id,
    );

    const displayName = computed(() =>
        props.viewOption.is_default
            ? t('datatables.view_options.default')
            : props.viewOption.name || t('datatables.view_options.placeholder'),
    );

    const mutation = useMutation({
        mutationFn: async () => {
            return await axios.patch(
                route('v2.dashboard.view-options.update', props.viewOption.id),
                { name: name.value },
            );
        },
        onSuccess: () => {
            viewOptionsStore.updateViewOption(props.viewOption.id, name.value);
        },
        onError: (error) => {
            console.error(error);
        },
    });

    const updateState = (state: 'cancel' | 'submit' | 'edit') => {
        viewOptionsStore.setState(state);
        viewOptionsStore.removeDefaultEditing(props.viewOption.id);
    };

    const toggleGlobal = () => {
        viewOptionsStore.toggleGlobal(props.viewOption);
    };

return (_ctx: any,_cache: any) => {
  return (canManage.value)
    ? (_openBlock(), _createBlock(_unref(EditableRoot), {
        key: 0,
        modelValue: name.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
        placeholder: _unref(t)('datatables.view_options.placeholder'),
        class: "flex w-full items-center gap-2 px-2",
        "submit-mode": "enter",
        "activation-mode": "none",
        onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_unref(mutation).mutate())),
        "start-with-edit-mode": _ctx.viewOption.default_editing,
        "onUpdate:state": updateState
      }, {
        default: _withCtx(({ isEditing }) => [
          _createVNode(_unref(EditableArea), { class: "text-foreground w-full text-xs" }, {
            default: _withCtx(() => [
              _createVNode(_unref(EditablePreview), {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(viewOptionsStore).setActive(_ctx.viewOption))),
                class: _normalizeClass(["hover:text-primary flex h-7 cursor-pointer items-center", { 'font-bold': isActive.value }])
              }, null, 8, ["class"]),
              _createVNode(_unref(EditableInput), { class: "placeholder:text-faded-foreground w-full py-1 outline-none placeholder:text-xs" })
            ]),
            _: 1
          }),
          (!isEditing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (canShareGlobal.value || _ctx.viewOption.is_global)
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 0,
                      variant: _ctx.viewOption.is_global ? 'continue' : 'ghost',
                      size: "icon_sm",
                      class: _normalizeClass(
                    _ctx.viewOption.is_global
                        ? undefined
                        : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                ),
                      title: 
                    _ctx.viewOption.is_global
                        ? _unref(t)('datatables.view_options.make_personal')
                        : _unref(t)('datatables.view_options.make_global')
                ,
                      onClick: toggleGlobal
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Globe))
                      ]),
                      _: 1
                    }, 8, ["variant", "class", "title"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_2)),
                _createVNode(_unref(EditableEditTrigger), { "as-child": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      variant: "edit",
                      size: "icon_sm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Pencil))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(ViewOptionDelete, {
                  "view-option-id": _ctx.viewOption.id
                }, null, 8, ["view-option-id"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(EditableSubmitTrigger), { "as-child": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      variant: "accent",
                      size: "icon_sm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Check))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(EditableCancelTrigger), { "as-child": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      variant: "delete",
                      size: "icon_sm"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(X))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder", "start-with-edit-mode"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("span", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(viewOptionsStore).setActive(_ctx.viewOption))),
          class: _normalizeClass(["text-foreground hover:text-primary flex h-7 min-w-0 flex-1 cursor-pointer items-center text-xs", { 'font-bold': isActive.value }])
        }, _toDisplayString(displayName.value), 3),
        _createElementVNode("div", _hoisted_5, [
          _cache[4] || (_cache[4] = _createElementVNode("span", {
            class: "size-7 shrink-0",
            "aria-hidden": "true"
          }, null, -1)),
          _cache[5] || (_cache[5] = _createElementVNode("span", {
            class: "size-7 shrink-0",
            "aria-hidden": "true"
          }, null, -1)),
          _createVNode(_unref(Button), {
            variant: "ghost",
            size: "icon_sm",
            disabled: "",
            tabindex: "-1",
            class: "text-muted-foreground pointer-events-none opacity-100",
            title: 
                    _ctx.viewOption.is_default
                        ? _unref(t)('datatables.view_options.default')
                        : _unref(t)('datatables.view_options.shared')
                
          }, {
            default: _withCtx(() => [
              (_ctx.viewOption.is_default)
                ? (_openBlock(), _createBlock(_unref(Lock), { key: 0 }))
                : (_openBlock(), _createBlock(_unref(Globe), { key: 1 }))
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ]))
}
}

})